import { ActivatedRouteSnapshot, ResolveFn, Route, RouterStateSnapshot } from '@angular/router';
import { ICodetableItem } from '@mng/mgs-lib';
import { inject } from '@angular/core';
import { codetableResolver } from '../../codetable/codetable.resolver';
import { mgsIconsResolver } from '../../mgs-svg-icon.helper';
import { partnerDetailResolver } from './partner-detail.resolver';
import { PartnerDetailService } from './partner-detail.service';
import { partnerResolver } from '../partner.resolver';

export const bundeslaenderResolver: ResolveFn<ICodetableItem[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(PartnerDetailService).resolveBundeslaender();
};

export const PARTNER_DETAIL_PATH = 'partnerdetail';

export const partnerDetailRoute: Route = {
  path: PARTNER_DETAIL_PATH,
  title: 'Partner Detail',
  resolve: {
    partner: partnerResolver,
    partnerDetail: partnerDetailResolver,
    bundeslaender: bundeslaenderResolver,
    codetable: codetableResolver,
    icons: mgsIconsResolver
  },
  loadComponent: () => import('./partner-detail.component').then((c) => c.PartnerDetailComponent)
};
